// Libs
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Context
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import { useComponentsPool } from '../../../../ComponentsPool';
import { Toast } from '../../../notification/components';
import { useModal } from '../../../modal/ModalContext';
// Actions
import createLoadingSelector from '../../../layout/actions';
import { addBuildingsFromCSV, getGroupList } from '../../actions';

const loadingSelector = createLoadingSelector(['ADD_SKILLS_CSV_FILE']);

const CSVAddBuildingsPopup = () => {
    const isLoading = useSelector(state => loadingSelector(state.layout.loading));
    const { Component } = useComponentsPool();
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const modal = useModal();
    const choosePicture = React.createRef();
    const [csvFile, setCsvFile] = useState('');
    const [isCompliantCsvFile, setIsCompliantCsvFile] = useState(false);

    const showUploader = () => {
        choosePicture.current.click();
    };

    const fileChangedHandler = e => {
        e.preventDefault();
        if (e.target.files?.length > 0) {
            setCsvFile(e.target.files[0]);
            if (e.target.files[0].size < 2500000) {
                setIsCompliantCsvFile(true);
            } else {
                setIsCompliantCsvFile(false);
                toast(
                    <Toast
                        isConfirm
                        message={t('notifications:is_not_compliant_device_csv')}
                        icon={'frown'}
                        type={'error'}
                    />, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        className: 'normal',
                        bodyClassName: 'notification-body grow-font-size',
                        progressClassName: 'error-custom-progress-bar'
                    }
                );
            }
        }
    };

    const addBuildings = async () => {
        dispatch(addBuildingsFromCSV(csvFile))
            .then(() => {
                dispatch(getGroupList());
                modal.close();
            });
    };

    const Form = (
        <div className={'csv-popup'}>
            <div className={'add-csv-file'}>
                <div className="doc-links">
                    <a href="https://www.notion.so/merciyanis/B-timents-6c8db9023ec3448f902316337f83d407?pvs=4"
                       rel="noopener noreferrer" target="_blank">
                        {t('common:doc_link')}
                    </a>
                    <br />
                    <br />
                    <a href="https://docs.google.com/spreadsheets/d/1X1gFQGJ2U7YZ-TwX9xSRnD_dDLDQ_W3X9E8SwyG1atU/edit#gid=0"
                       rel="noopener noreferrer" target="_blank">
                        {t('common:csv_link')}
                    </a>
                </div>
                 <br />
                <Button
                    onClick={showUploader}
                >
                    <span>{t('common:import_csv_file')}</span>
                </Button>
            </div>
            <input
                ref={choosePicture}
                hidden
                type="file"
                accept=".csv"
                onChange={e => fileChangedHandler(e)}
            />
            <div>
                <span>{t('common:imported_file') + (csvFile ? ` ${csvFile.name}` : ` ${t('common:none')}`)}</span>
            </div>
        </div>
    );

    const disableSave = !isCompliantCsvFile || !csvFile;

    return (
        <>
            <Component componentName={'LoaderBarTop'} isLoading={isLoading} />
            <Component
                componentName={'Modal'}
                noOverflow
                head={<span className={'title-ticket-create-popup'}>{t('csv:add_buildings_from_csv')}</span>}
                content={Form}
                classNames={'ticket-create-popup'}
                submitButton
                submitButtonLabel={'common:save'}
                onHandleSubmit={addBuildings}
                onSubmitDisabled={disableSave}
            />
        </>
    );
};
export default CSVAddBuildingsPopup;
